import { useEffect } from 'react';

const BASE_TITLE = 'Dekon SSO';

/** Sets the browser-tab title to "<page> – Dekon SSO" while the page is shown. */
export function usePageTitle(title?: string): void {
    useEffect(() => {
        document.title = title && title !== BASE_TITLE ? `${title} – ${BASE_TITLE}` : BASE_TITLE;
    }, [title]);
}
